<template>
	<edit></edit>
</template>

<script>
	import edit from './stationed_auth_edit.vue'
	
	export default {
		name: 'stationed_auth_add',
		
		components: {
			edit
		}
	}
</script>